export const tokenKeyword = 'ocean_token_v1';

export function getCookie(cname) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return '';
}

const TokenStorage = {
  get: () => JSON.parse(localStorage.getItem(tokenKeyword)),

  set: (value) => {
    localStorage.setItem(tokenKeyword, JSON.stringify(value));

    return true;
  },

  destroy: () => {
    localStorage.removeItem(tokenKeyword);
  },

  clear: () => {
    localStorage.removeItem(tokenKeyword);
  }

  /*
  COOKIE STORAGE
  get: () => {
    try {
      const token = getCookie(tokenKeyword);

      if (token) {
        return JSON.parse(token);
      }

      return '';
    } catch (error) {
      console.warn(error);

      return '';
    }
  },

  set: (value) => {
    let expire = 7200 * 60; // 5 days
    const stringifiedToken = JSON.stringify(value);
    const diffinseconds = new Date().getTimezoneOffset() * 60;
    expire += diffinseconds > 0 ? diffinseconds : -diffinseconds;

    if (process.env.NODE_ENV === 'development') document.cookie = `${tokenKeyword}=${stringifiedToken}; path=/; max-age=${expire}; samesite=lax;`;
    else document.cookie = `${tokenKeyword}=${stringifiedToken}; path=/; max-age=${expire}; samesite=lax; secure`;

    return true;
  },

  destroy: () => {
    document.cookie = `${tokenKeyword}=null; path=/; max-age=0; samesite=lax`;
  },

  clear: () => {
    document.cookie = `${tokenKeyword}=null; path=/; max-age=0; samesite=lax`;
  }
 */
  // isExpired: () => {
  //   const { expires_in, created_at } = TokenStorage.get();

  //   const expireMinutes = expires_in / 60;
  //   const createdDate = new Date(created_at * 1000);
  //   const expireDate = new Date(createdDate.getTime() + (expireMinutes * 60000));

  //   const isExpired = createdDate > expireDate;

  //   return isExpired;
  // }
};

export default TokenStorage;
